import { TimelineConstants } from '../_constants';

export function timelines(state = {}, action) {
  switch (action.type) {
    case TimelineConstants.POPULATE_TIMELINES:
      return {
        items: action.payload ? action.payload : [],
      };

    case TimelineConstants.CREATE_REQUEST:
      return {
        ...state,
        error: null,
        loading: true,
        params: action.params,
      };

    case TimelineConstants.CREATE_SUCCESS:
      return {
        ...state,
        error: undefined,
        loading: false,
        params: undefined,
        items: [...state?.items, action.payload],
      };

    case TimelineConstants.CREATE_FAILURE: {
      return {
        ...state,
        error: action.error,
        loading: false,
        params: undefined,
      };
    }

    // UPDATE TIMELINES
    case TimelineConstants.UPDATE_REQUEST: {
      const { params } = action;

      return {
        ...state,
        error: undefined,
        params,
        loading: true,
      };
    }

    case TimelineConstants.UPDATE_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload._id);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        payload,
        ...state.items.slice(oldItemIndex + 1),
      ];

      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: newItems,
      };
    }

    case TimelineConstants.UPDATE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
      };
    }

    case TimelineConstants.DELETE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case TimelineConstants.DELETE_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload);
      const newItems = [
        ...state.items.slice(0, oldItemIndex),
        ...state.items.slice(oldItemIndex + 1),
      ];

      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: newItems,
      };
    }

    case TimelineConstants.DELETE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        params: undefined,
        loading: false,
        error,
      };
    }
    default:
      return state;
  }
}
